module.exports = __webpack_public_path__ + "static/media/BarbaraElo.d464b2fe.png";